"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateSettings = exports.fetchSettings = void 0;
const abortable_fetch_1 = require("../../../utils/abortable-fetch");
/**
 * Load user settings.
 *
 * @param url Url of service
 */
function fetchSettings(url) {
    return abortable_fetch_1.abortableFetch(url, {
        method: 'GET',
    });
}
exports.fetchSettings = fetchSettings;
/**
 * Saves user settings.
 *
 * @param url Url of service
 */
function updateSettings(url, settings) {
    return abortable_fetch_1.abortableFetch(url, {
        method: 'PUT',
        body: JSON.stringify(settings),
    });
}
exports.updateSettings = updateSettings;
//# sourceMappingURL=app-settings-api.js.map